import AppActivityApi from './AppActivityApi';
import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import AppActivityCreateEditForm from './Components/AppActivityCreateEditForm';


export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: AppActivityCreateEditForm,
                getCreate: AppActivityApi.create,
                getClone: AppActivityApi.getOne,
                defaults: {},
                successMessage: "Avatar Saved Successfully!",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}